export const trackEvent = (eventName: string) => {
  // biome-ignore lint/complexity/useLiteralKeys: wts is appendes to window-object by Mapp
  if (window['wts']) {
    // biome-ignore lint/complexity/useLiteralKeys: see above
    window['wts'].push(['send', 'click', { linkId: eventName }]);
  }
};
